module.exports = __webpack_public_path__ + "img/bg43.528f05f1.png";